module.exports = __webpack_public_path__ + "images/3121ccd134b40641cb9c5572af7250e0.svg";